import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { TaxPlannerDialogProps } from './types';

export const TAX_PLANNER_DIALOG = 'TAX_PLANNER_DIALOG';

export const dispatchTaxPlannerDialog = (props?: TaxPlannerDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: TAX_PLANNER_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchTaxPlannerDialog;
